export const companyDivisionIds = {
  AshtromResidentialForRent: 8,
  AshtromProperties: 9,
  AshtromIndustries: 12,
  International: 2,
  Melet: 25,
  Ashcrete: 14,
  Ashdar: 5,
  Base: 16,
  Construction: 11,
  Engineering: 6,
  Drachim: 17,
  Energy: 3,
  AshtromJerusalem: 7,
  AshtromNorth: 10,
  Contracting: 32,
  Franchise: 33,
}

export const ADVANCED_RENT_PAYMENT_AMOUNT = 2000
